import config from "../config/config";

const DEFAULT_LINK_ID = "theme-favicon";

/**
 * Absolute URL for a theme favicon path from the API (e.g. /uploads/company-logos/x.ico).
 */
export function themeFaviconHref(faviconPath, cacheBust) {
  if (faviconPath == null || typeof faviconPath !== "string") return null;
  const p = faviconPath.trim();
  if (!p) return null;
  if (p.startsWith("http") || p.startsWith("blob:")) {
    return appendCacheBust(p, cacheBust);
  }
  const base = (config.assetsBaseUrl || "").replace(/\/$/, "");
  const path = p.startsWith("/") ? p : `/${p}`;
  return appendCacheBust(`${base}${path}`, cacheBust);
}

function appendCacheBust(url, bust) {
  if (bust == null || bust === "") return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}v=${encodeURIComponent(String(bust))}`;
}

function guessIconType(href) {
  const u = href.split("?")[0].toLowerCase();
  if (u.endsWith(".png")) return "image/png";
  if (u.endsWith(".svg")) return "image/svg+xml";
  if (u.endsWith(".ico")) return "image/x-icon";
  if (u.endsWith(".webp")) return "image/webp";
  return null;
}

/**
 * Updates <link rel="icon"> in document head (prefers #theme-favicon from index.html).
 */
export function applyThemeFavicon(faviconPath, options = {}) {
  if (typeof document === "undefined") return;
  const { linkId = DEFAULT_LINK_ID, cacheBust } = options;
  const href = themeFaviconHref(faviconPath, cacheBust);
  if (!href) return;

  let link =
    document.getElementById(linkId) ||
    document.querySelector('link[rel="icon"]') ||
    document.querySelector('link[rel="shortcut icon"]');

  if (!link) {
    link = document.createElement("link");
    link.id = linkId;
    link.rel = "icon";
    document.head.appendChild(link);
  } else if (linkId && !link.id) {
    link.id = linkId;
  }

  const mime = guessIconType(href);
  if (mime) link.type = mime;
  else link.removeAttribute("type");

  link.href = href;
}
